<template>
  <div class="tool-detail-page white-theme pollo-layout">
    <div class="container">
      <section class="first-screen">
      <div class="breadcrumb">
        <router-link to="/">{{ $t('modelDetail.breadcrumb.home') }}</router-link>
        <span>&rsaquo;</span>
        <router-link to="/tools">{{ $t('tools.page.allTools') }}</router-link>
        <span>&rsaquo;</span>
        <span>{{ toolName }}</span>
      </div>

      <div class="first-screen-grid"><div class="action-column">
      <!-- 未登录拦截 -->
      <div v-if="!isLoggedIn" class="login-prompt">
        <div class="login-prompt-content">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" stroke-width="1"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          <h2>{{ $t('tools.detail.loginRequired') }}</h2>
          <p>{{ $t('tools.detail.loginRequiredDesc') }}</p>
          <button class="btn btn-primary" @click="goLogin">{{ $t('tools.detail.loginNow') }}</button>
        </div>
      </div>

      <div v-else class="tool-interface">
        <!-- 错误提示 -->
        <div v-if="processError" class="tool-error--block">
          <p class="tool-error">{{ processError }}</p>
        </div>

        <!-- 涂抹画布组件：替代原来的上传+预览区 -->
        <InpaintCanvas
          ref="canvas"
          placeholder-text="点击或拖拽上传图片，然后用画笔涂抹要擦除的区域"
          @change="onCanvasChange"
        />

        <!-- 提示：涂抹后才能点 -->
        <div v-if="hasImage && !hasMask" class="inpaint-hint">
          请在图片上涂抹要擦除的区域
        </div>

        <!-- 操作按钮 -->
        <div class="tool-options">
          <button
            class="btn btn-primary btn-lg"
            :disabled="processing || !hasImage || !hasMask"
            @click="process"
          >
            <svg v-if="processing" class="spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            <span v-else>开始擦除</span>
          </button>
        </div>

        <!-- 结果区 -->
        <div class="tool-result legacy-tool-result" v-if="processing || processed">
          <div v-if="processing" class="gen-loading">
            <div class="loading-spinner"></div>
            <p>{{ $t('tools.detail.processing') }}</p>
          </div>
          <div v-else class="tool-output">
            <div class="output-comparison">
              <div class="output-before">
                <span class="output-label">{{ $t('tools.detail.before') }}</span>
                <div class="output-image output-image--fill">
                  <img v-if="previewSrc" :src="previewSrc" alt="Before" class="compare-img">
                </div>
              </div>
              <div class="output-after">
                <span class="output-label">{{ $t('tools.detail.after') }}</span>
                <div class="output-image output-image--fill">
                  <img v-if="resultSrc" :src="resultSrc" alt="After" class="compare-img">
                </div>
              </div>
            </div>
            <div class="output-actions">
              <button v-if="resultSrc" type="button" class="btn btn-primary" @click="downloadResult">⬇️ {{ $t('tools.detail.download') }}</button>
              <button class="btn btn-secondary" @click="reset">{{ $t('tools.detail.processNew') }}</button>
            </div>
          </div>
        </div>
      </div>

        </div><div class="showcase-column">
      <div class="tool-hero"><div class="tool-hero-info"><h1>{{ toolName }}</h1><p class="tool-hero-desc">{{ $t('brandSeo.toolDescription', { description: toolDesc }) }}</p></div></div>
      <!-- 效果演示 -->
      <div class="demo-section workspace-panel" v-if="!processing && !processed">
        <h2 class="demo-title">{{ $t('tools.detail.demo') }}</h2>
        <div class="demo-comparison">
          <div class="demo-item">
            <span class="demo-label">{{ $t('tools.detail.before') }}</span>
            <div class="demo-image">
              <img src="@/assets/images/image-eraser1.jpg" alt="Before">
            </div>
          </div>
          <div class="demo-arrow">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </div>
          <div class="demo-item">
            <span class="demo-label">{{ $t('tools.detail.after') }}</span>
            <div class="demo-image">
              <img src="@/assets/images/image-eraser2.png" alt="After">
            </div>
          </div>
        </div>
      </div>
      <div class="processing-panel workspace-panel" v-else-if="processing"><div class="workspace-heading"><h2>{{ $t('tools.detail.processing') }}</h2></div><div class="processing-preview"><img v-if="previewSrc" :src="previewSrc" alt="Processing preview"><div class="processing-overlay"><div class="loading-spinner"></div></div></div><div class="processing-track"><span></span></div></div>
      <div class="result-panel workspace-panel" v-else><div class="workspace-heading"><h2>{{ $t('tools.detail.after') }}</h2></div><div class="output-comparison"><div class="output-before"><span class="output-label">{{ $t('tools.detail.before') }}</span><div class="output-image output-image--fill"><img v-if="previewSrc" :src="previewSrc" alt="Before" class="compare-img"></div></div><div class="output-after"><span class="output-label">{{ $t('tools.detail.after') }}</span><div class="output-image output-image--fill"><img v-if="resultSrc" :src="resultSrc" alt="After" class="compare-img"></div></div></div><div class="output-actions"><button v-if="resultSrc" type="button" class="btn btn-primary" @click="downloadResult">{{ $t('tools.detail.download') }}</button><button class="btn btn-secondary" @click="reset">{{ $t('tools.detail.processNew') }}</button></div></div>
        </div></div>
      </section>

      <!-- 使用说明 -->
      <div class="detail-section" style="margin-top:64px;">
        <h2>{{ $t('tools.detail.howToUse') }}</h2>
        <div class="steps">
          <div class="step" v-for="(step, idx) in steps" :key="idx">
            <div class="step-number">{{ idx + 1 }}</div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </div>
        </div>
      </div>

      <!-- 更多工具 -->
      <div class="detail-section">
        <h2>{{ $t('tools.detail.moreTools') }}</h2>
        <div class="grid-5">
          <ToolListCard
            v-for="t in otherTools"
            :key="t.id"
            :tool-id="t.id"
            :icon="t.icon"
            :badge="t.badge"
            :to="'/tools/' + t.id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InpaintCanvas from '@/components/InpaintCanvas.vue'
import { submitInpaint, pollInpaint } from '@/api/comfyui'
import { saveOrUpdateAIHistory, formatCreateDate, uploadFile } from '@/api'
import { isAuthenticated } from '@/api/auth'
import ToolListCard from '@/components/ToolListCard.vue'

export default {
  name: 'InpaintDetail',
  components: { InpaintCanvas, ToolListCard },
  data() {
    return {
      hasImage: false,        // 是否已上传图片
      hasMask: false,         // 是否已涂抹
      previewSrc: '',         // 原图预览（对比用）
      processing: false,
      processed: false,
      resultSrc: '',          // 擦除结果图 URL
      processError: null,
      poller: null
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.userInfo
    },
    toolName() {
      return this.$t("tools['image-eraser'].name")
    },
    toolDesc() {
      return this.$t("tools['image-eraser'].fullDesc")
    },
    otherTools() {
      return this.$store.state.tools.filter(function(t) { return t.id !== 'image-eraser' }).slice(0, 5)
    },
    steps() {
      return [
        { title: '上传图片', desc: '点击或拖拽上传你要处理的图片' },
        { title: '涂抹区域', desc: '用画笔在图上涂抹你想擦除的物体或水印' },
        { title: '开始擦除', desc: '点击开始擦除，等待 AI 处理完成后下载结果' }
      ]
    }
  },
  beforeDestroy() {
    if (this.poller) {
      this.poller.stop()
      this.poller = null
    }
  },
  methods: {
    goLogin() {
      this.$store.dispatch('showLoginModal')
    },

    /* InpaintCanvas 抛出的 change 事件 */
    onCanvasChange(e) {
      this.hasImage = !!e.imageBlob
      this.hasMask = !!e.hasMask
      /* 同步原图预览（用于结果对比） */
      if (e.imageBlob) {
        var reader = new FileReader()
        var self = this
        reader.onload = function(ev) {
          self.previewSrc = ev.target && ev.target.result ? String(ev.target.result) : ''
        }
        reader.readAsDataURL(e.imageBlob)
      } else {
        this.previewSrc = ''
      }
    },

    /* 核心流程：提交 + 轮询，套用 BackgroundRemoverDetail 的历史记录模式 */
    process() {
      var self = this
      if (!this.hasImage || !this.hasMask) return
      this.processing = true
      this.processed = false
      this.processError = null

      var canvas = this.$refs.canvas
      var imageBlob = canvas.getImageBlob()
      var maskBlob = null

      var createDate = formatCreateDate(new Date())
      var aiName = this.toolName
      var aiDesc = this.toolName
      var historyId = null
      var originalUrl = ''

      /* 1. 导出 mask blob */
      canvas.getMaskBlob().then(function(blob) {
        maskBlob = blob
        /* 2. 上传原图到服务器（历史记录用） */
        return uploadFile(imageBlob)
      }).then(function(url) {
        originalUrl = url
      }).catch(function() {
        self.processing = false
        self.processError = self.$t('tools.detail.uploadOriginalFailed')
        return Promise.reject('uploadOriginalFailed')
      }).then(function() {
        /* 3. 创建历史记录 */
        return saveOrUpdateAIHistory({
          aiName: aiName,
          taskId: '',
          aiDesc: aiDesc,
          state: 1,
          aiResultUrl: '',
          image_large_url: originalUrl,
          aiMediaType: 'image',
          createDate: createDate
        })
      }).then(function(hRes) {
        historyId = hRes && (hRes.historyId != null ? hRes.historyId : null)
      }).then(function() {
        /* 4. 提交擦除任务 */
        return submitInpaint({ imageUrl: originalUrl, maskFile: maskBlob })
      }).then(function(res) {
        /* 5. 轮询结果 */
        self.poller = pollInpaint(res.promptId, function(err, imageUrl) {
          self.poller = null
          if (err) {
            self.onFailed(err, historyId, aiName, aiDesc, originalUrl, createDate)
          } else {
            self.onSuccess(imageUrl, historyId, aiName, aiDesc, originalUrl, createDate)
          }
        })
      }).catch(function(err) {
        if (err === 'uploadOriginalFailed') return
        self.processing = false
        self.processed = false
        self.resultSrc = ''
        self.processError = self.$userFacingError(err, self.$t('common.generateFailedContactSupport'))
      })
    },

    onSuccess(imageUrl, historyId, aiName, aiDesc, originalUrl, createDate) {
      var self = this
      self.processing = false
      self.resultSrc = imageUrl
      self.processed = true
      self.processError = null
      /* 更新历史记录为成功 */
      saveOrUpdateAIHistory({
        aiName: aiName || self.toolName,
        historyId: historyId,
        taskId: '',
        aiDesc: aiDesc || self.toolName,
        state: 2,
        aiResultUrl: imageUrl || '',
        image_large_url: originalUrl || '',
        aiMediaType: 'image',
        createDate: createDate || formatCreateDate(new Date())
      }).catch(function() {})
    },

    onFailed(err, historyId, aiName, aiDesc, originalUrl, createDate) {
      this.processing = false
      this.processed = false
      this.resultSrc = ''
      this.processError = this.$userFacingError(err, this.$t('common.generateFailedContactSupport'))
      saveOrUpdateAIHistory({
        aiName: aiName || this.toolName,
        historyId: historyId,
        taskId: '',
        aiDesc: aiDesc || this.toolName,
        state: 3,
        message: (err && err.message) ? err.message : '',
        aiResultUrl: '',
        image_large_url: originalUrl || '',
        aiMediaType: 'image',
        createDate: createDate || formatCreateDate(new Date())
      }).catch(function() {})
    },

    downloadResult() {
      if (!this.resultSrc) return
      var url = this.resultSrc
      var a = document.createElement('a')
      a.href = url
      a.download = 'inpaint-erased.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    reset() {
      this.processed = false
      this.resultSrc = ''
      this.processError = null
      if (this.$refs.canvas) this.$refs.canvas.reset()
      this.hasImage = false
      this.hasMask = false
      this.previewSrc = ''
    }
  }
}
</script>

<style scoped>
@import '../styles/toolPolloLayout.css';

@import './ModelDetailStyles.css';

.tool-detail-page { padding: 48px 0 80px; }
.breadcrumb { display: flex; align-items: center; gap: 8px; margin-bottom: 32px; font-size: 13px; color: var(--text-muted); }
.breadcrumb a { color: var(--text-secondary); }
.breadcrumb a:hover { color: var(--accent); }
.tool-hero { margin-bottom: 32px; }
.tool-hero-info { text-align: center; max-width: 640px; margin: 0 auto; }
.tool-icon-lg { font-size: 48px; display: block; margin-bottom: 16px; }
.tool-hero-info h1 { font-size: 36px; font-weight: 800; margin-bottom: 12px; }
.tool-hero-desc { font-size: 16px; color: var(--text-secondary); line-height: 1.7; margin-bottom: 24px; }
.login-prompt { background: var(--bg-card); border: 1px solid var(--bg-card-border); border-radius: var(--radius-xl); padding: 24px 28px; text-align: center; margin: 32px auto 0; max-width: 680px; }
.login-prompt-content { max-width: 360px; margin: 0 auto; }
.login-prompt-content svg { display: block; margin: 0 auto; }
.login-prompt h2 { margin: 6px 0 4px; font-size: 20px; }
.login-prompt p { color: var(--text-muted); font-size: 14px; margin-bottom: 12px; }
.tool-interface { background: var(--bg-card); border: 1px solid var(--bg-card-border); border-radius: var(--radius-xl); padding: 32px; margin: 32px auto 0; max-width: 760px; }
.tool-error { color: #f87171; font-size: 13px; margin: 0 0 12px; }
.tool-error--block { text-align: center; margin-bottom: 16px; }
.output-image--fill { padding: 0; overflow: hidden; background: var(--bg-primary); }
.compare-img { width: 100%; height: 100%; object-fit: contain; display: block; min-height: 200px; max-height: 420px; background: var(--bg-primary); }
.tool-options { display: flex; align-items: flex-end; gap: 16px; margin-top: 16px; justify-content: center; }
.tool-result { margin-top: 32px; }
.gen-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 200px; gap: 12px; }
.loading-spinner { width: 40px; height: 40px; border: 3px solid var(--border-color); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.output-comparison { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
.output-label { display: block; font-size: 12px; font-weight: 600; color: var(--text-muted); margin-bottom: 8px; text-transform: uppercase; }
.output-image { aspect-ratio: 1; border-radius: var(--radius-lg); display: flex; align-items: center; justify-content: center; }
.output-actions { display: flex; gap: 12px; justify-content: center; margin-top: 12px; }
/* 效果演示对比图 */
.demo-section { margin: 32px auto 0; padding: 24px; background: var(--bg-primary); border-radius: var(--radius-lg); max-width: 760px; }
.demo-title { font-size: 16px; font-weight: 600; text-align: center; margin-bottom: 20px; color: var(--text-primary); }
.demo-comparison { display: flex; align-items: center; justify-content: center; gap: 24px; flex-wrap: wrap; }
.demo-item { flex: 1; min-width: 200px; max-width: 300px; }
.demo-label { display: block; font-size: 12px; font-weight: 600; color: var(--text-muted); margin-bottom: 8px; text-transform: uppercase; text-align: center; }
.demo-image { aspect-ratio: 3/4; border-radius: var(--radius-lg); overflow: hidden; background: var(--bg-secondary); }
.demo-image img { width: 100%; height: 100%; object-fit: cover; }
.demo-arrow { color: var(--text-muted); flex-shrink: 0; }
.inpaint-hint { text-align: center; color: var(--text-muted); font-size: 14px; margin-top: 12px; }
.detail-section { margin-bottom: 64px; }
.detail-section h2 { font-size: 24px; font-weight: 700; margin-bottom: 24px; }
.steps { display: flex; justify-content: center; gap: 48px; flex-wrap: wrap; }
.step { text-align: center; }
.step-number { width: 40px; height: 40px; border-radius: 50%; background: var(--accent); color: #000; display: flex; align-items: center; justify-content: center; font-weight: 700; margin: 0 auto 12px; }
.step h3 { margin-bottom: 6px; }
.step p { font-size: 13px; color: var(--text-muted); }
.spinner { animation: spin 1s linear infinite; }
@media (max-width: 768px) { .steps { grid-template-columns: repeat(2, 1fr); } .output-comparison { grid-template-columns: 1fr; } }
</style>
